import request from "../Requests/requests";
// import { loadUserSettings } from "../store/settingsReducer";

export const editDataUser = (payload) => {
    return async () => {
        try {
            const response = await request.put('/Account/User/', {
                userId: localStorage.getItem('userID'),
                nickname: payload.nickname,
                name: payload.name,
                lastname: payload.lastname,
                birthday: payload.birthday,
                email: payload.email,
                position: payload.position
            })
            const data = response.data
            return data
        } catch (error) {
            return error
        }
        
        // dispatch(loadUserSettings(payload));
    }
}